const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0x765277EebeCA2e31912C9946eAe1021199B39C61',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0xfA9343C3897324496A05fC75abeD6bAC29f8A40f',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0xB44a9B6905aF7c801311e8F4E76932ee959c663C',
    },
    wkava: {
        id: 'wkava',
        type: REFERENCE_ASSETS.WKAVA,
        symbol: 'wKAVA',
        decimals: 1e18,
        address: '0xc86c7C0eFbd6A49B35E8714C5f59D99De09A225b',
        coingeckoId: 'kava',
    },
};
